import { blockHomeSlider } from "./block-home-slider";
import { menu } from "./menu";

/** Init */
jQuery(function ($) {
  menu();
  blockHomeSlider();
});
